// Honestly why not
const ADJS = [
  'burnt',
  'steamed',
  'charred',
  'spongy',
  'enlightened',
  'gentle',
  'fast',
  'slow',
  'crispy',
  'round',
  'toasted',
  'whole grain',
  'frothy',
  'enraged',
  'organic',
  'stylish',
];

const NOUNS = [
  'toast',
  'waffle',
  'bacon',
  'kitten',
  'potato',
  'brick',
  'hammer',
  'tumbleweed',
  'avocado',
  'chicken',
  'nail',
  'gecko'
];

function buildName() {
  const adj = ADJS[Math.floor(Math.random() * ADJS.length)];
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)];
  return `${adj} ${noun}`;
}

module.exports = {
  buildName,
}
